import { createMemo, For, Index, Show } from "solid-js";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getLanguageName } from "@/constants/languages";
import { getFlagIcon } from "@/constants/nationality-flags";
import { SkillBadge } from "./SkillBadge";

export const SkillsTags = (props: {
  skills: string[];
  slicedSkills: string[];
  withTooltip?: boolean;
}) => {
  return (
    <>
      <Index each={props.slicedSkills}>
        {(skill) => <SkillBadge skill={skill()} />}
      </Index>
      <Show
        when={
          props.skills?.length &&
          props.skills?.length > (props.slicedSkills?.length ?? 0)
        }
      >
        <Show
          when={props.withTooltip}
          fallback={
            <Badge variant="warning" size="sm">
              +{props.skills!.length - 3}
            </Badge>
          }
        >
          <Tooltip>
            <TooltipTrigger>
              <Badge variant="warning" size="sm">
                +{props.skills!.length - 3}
              </Badge>
            </TooltipTrigger>
            <TooltipContent class="bg-white p-4 shadow-md">
              <div class="flex flex-wrap gap-1">
                <For each={props.skills!.slice(3)}>
                  {(skill) => (
                    <Badge variant="secondary" size="sm">
                      {skill}
                    </Badge>
                  )}
                </For>
              </div>
            </TooltipContent>
          </Tooltip>
        </Show>
      </Show>
    </>
  );
};

export const LanguagesTags = (props: {
  languages: Record<string, string>;
  flags_only?: boolean;
}) => {
  const languages = createMemo(() =>
    Object.entries(props.languages).map(([language, level]) => ({
      language: props.flags_only
        ? getFlagIcon(language)
        : `${getFlagIcon(language)} ${getLanguageName(language)}`,
      level,
    })),
  );
  return (
    <Index each={languages()}>
      {(language) => (
        <Badge variant="secondary" size="sm">
          {language().language} • {language().level}
        </Badge>
      )}
    </Index>
  );
};
